module.exports = __webpack_public_path__ + "static/media/modern-data-stack-technical-roadmap.07e32360.jpg";